import { render, staticRenderFns } from "./draft.vue?vue&type=template&id=bb6f32ac&"
import script from "./draft.vue?vue&type=script&lang=js&"
export * from "./draft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs-edu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb6f32ac')) {
      api.createRecord('bb6f32ac', component.options)
    } else {
      api.reload('bb6f32ac', component.options)
    }
    module.hot.accept("./draft.vue?vue&type=template&id=bb6f32ac&", function () {
      api.rerender('bb6f32ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/message/draft.vue"
export default component.exports